/* repo/card*/
import { lensPath } from "ramda";
import {
  fetch as fetchApi,
  insert as insertApi,
  drop as dropApi,
  isString,
} from "./api";
import { CardCodec, Card, Data } from "../store/card/types";
import { withDecoded, flattenData } from "./";

export function getNewCard(): Data {
  return {
    id: null,
    type: "Card",
    attributes: {
      Name: "",
      CardBin: [],
    },
  };
}
function mapToModel(data: object): Card {
  return withDecoded(CardCodec, data, (decoded) => ({
    ...decoded,
  }));
}

function mapToChageset(processor: Data): Data {
  return processor;
}

export async function fetch(id: string | null, params?: {}): Promise<Card> {
  return fetchApi({
    nestedResourcePath: ["card"],
    id: id,
    params: params,
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function save(processor: Data): Promise<Card> {
  return insertApi({
    nestedResourcePath: ["card"],
    id: processor.id,
    data: { data: mapToChageset(processor) },
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function drop(id: string | null): Promise<boolean> {
  return dropApi({
    nestedResourcePath: ["card"],
    id: id,
  }).then(() => true);
}
